import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import ObservationsModal from "./ObservationsModal";
import AddObservation from "./AddObservation";
import FilesListHelper from "../../../helpers/FilesListHelper";
import {
  getUsers,
  deleteUser,
  resourcesOperators,
  activeRoutes,
} from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getPolicyUser, getStorageUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";

const Operators = () => {
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalObserv, setModalObserv] = useState({
    show: false,
    type: 1,
    id: null,
  });
  const [modalFile, setModalFile] = useState({
    show: false,
    id: null,
    files: [],
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "name",
    order: "asc",
    companySession: authUser.company_id,
  });
  const [items, setItems] = useState([]);

  const [itemBase, setItemBase] = useState({
    id: null,
    name: "",
    lname1: "",
    lname2: "",
    key: "",
    certificate: false,
    key_name: "",
    date_procedure_license: null,
    date_expire_license: null,
    cellphone: "",
    nametag: "",
    unit_number: null,
    route_id: authUser.route_id,
    route: authUser.route,
    photo_id: null,
    email: "",
    certificate: false,
    unit_id: null,
    blood_type: null,
  });

  const [item, setItem] = useState(itemBase);
  const dispatch = useDispatch();
  useEffect(() => {
    console.log('filters',filters)
    const getOperators = async () => {
      console.log('getOperators')
      let params = { params: filters };
      const response = await resourcesOperators("get", params);
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    };
    getOperators();
  }, [filters]);

  const addUpd = (row = false) => {
    setItem(row.id ? row : itemBase);
    setModal({ ...modal, show: true, update: row.id ? true : false });
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesOperators("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const active = (row) => {
    activeRoutes(row).then((response) => {
      if (response.status) {
        console.log(response.route);
        let newItem = response.route;
        let array = items.map((item) =>
          item.id !== newItem.id ? item : newItem
        );
        setItems(array);
      }
    });
  };
  const columns = Columns(
    addUpd,
    destroy,
    active,
    setModalObserv,
    setModalFile,
    authUser
  );
  document.title = "Operadores | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Operadores"
              filterInp={true}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              {authUser.can.operators.create && (
                <div className="mb-3">
                  <ButtonHelper addButon={true} actionAddButon={addUpd} />
                </div>
              )}
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
          />
        )}

        {modalObserv.show && (
          <ObservationsModal
            modal={modalObserv}
            setModal={setModalObserv}
            id={modalObserv.id}
            authUser={authUser}
          />
        )}
        {modalObserv.show && modalObserv.type == 2 && (
          <AddObservation
            modal={modalObserv}
            setModal={setModalObserv}
            id={modalObserv.id}
            authUser={authUser}
          />
        )}
        {modalFile.show && (
          <FilesListHelper
            modal={modalFile}
            setModal={setModalFile}
            title="Archivos de Operadores"
            type="operator"
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Operators;
